import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { PortalBookingFlow } from '@/components/booking/portal-booking-flow'
import { PageHeader } from '@/components/page-header'
import { msg } from '@/i18n'
import { integer, matching, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/portal/reserver')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** L'hôte choisi (s'il y en a plusieurs). */
        hote: matching(/^[0-9a-f]{24}$/),
        /** La durée choisie, en minutes. */
        duree: integer({ min: 15 }),
        /** Le jour choisi, dans le fuseau du contact. */
        jour: matching(/^\d{4}-\d{2}-\d{2}$/),
      },
      search,
    ),
  component: PortalBookPage,
})

/** « Prendre rendez-vous » (lot 32) : chaque étape se garde dans l'adresse. */
function PortalBookPage() {
  const step = Route.useSearch()
  const navigate = useNavigate()
  return (
    <div className="space-y-5">
      <PageHeader title={msg().portalScheduling.book.title} />
      <PortalBookingFlow
        step={step}
        onStep={(next) => {
          void navigate({ to: '/portal/reserver', search: next, replace: true })
        }}
        onBooked={(booking) => {
          void navigate({
            to: '/portal/reservations/$bookingId',
            params: { bookingId: booking.id },
            search: { confirmee: true },
          })
        }}
      />
    </div>
  )
}
